export default __webpack_public_path__ + "static/media/ubuntu.57501be7.svg";